<ll-titulo>Ver Typeform widget</ll-titulo>
<ll-toolnavbar>
    <typeform-widget-toolnavbar [typeformWidgetId]="typeformWidgetId" [displayButtons]="'all,edit'"></typeform-widget-toolnavbar>
</ll-toolnavbar>

<typeform-widget></typeform-widget>
